
const setCookie = (name, value, days = 7, path = '/') => {
  const expires = new Date(Date.now() + days * 864e5).toUTCString()
  document.cookie = name + '=' + encodeURIComponent(value) + '; expires=' + expires + '; path=' + path
}

const getCookie = (name) => {
  return document.cookie.split('; ').reduce((r, v) => {
    const parts = v.split('=')
    return parts[0] === name ? decodeURIComponent(parts[1]) : r
  }, '') 
}

const deleteCookie = (name, path) => {
  setCookie(name, '', -1, path)
}


const productData = () => ({
  product: null,
  variants: [],
  selectedVariant: null,
  quantity: 1,
  decreaseQuantity() {
    this.quantity -= 1
    if (this.quantity <= 1) {
      this.quantity = 1
    }
    window.dispatchEvent( new CustomEvent('quantity-updated', {'detail': {quantity: this.quantity}}))
  },
  increaseQuantity() {
    this.quantity = this.quantity + 1
    window.dispatchEvent( new CustomEvent('quantity-updated', {'detail': {quantity: this.quantity}}))
  },
  productImage() {

  },
  selectVariant(id) {
    if (id) {
      this.selectedVariant = this.product.variants.find(item => item.id == id)
      window.dispatchEvent( new CustomEvent('variant-selected', {'detail': {id: this.selectedVariant.id, 'price': this.selectedVariant.price}}))
    }
  },
  initialize(product, variantId) {
    this.product = product
    if (product) {
      this.variants = product.variants
      this.selectedVariant = product.variants.find(item => item.id == variantId)
    }
  }
}); 



const discountedPrice = () => {
  return {
    discount: null,
    discountFound: false,
    loading: false,
    variantChanged(event) {
      var $this = this
      const dcr = getCookie("discount_code_referrer");
      if (dcr && window.productData) {
        $this.loading = true
        var coupon_code = dcr.toString();
        var url = `https://secretbrands-checkout-api.digitalsprung.de/checkout/${coupon_code.toLowerCase()}/${window.productData.productId}/${event.detail.id}?shop=${Shopify.shop}&price=${event.detail.price}`

        fetch(url)
        .then(response => response.json())
        .then(data => {
          setTimeout(() => {
            $this.loading = false
          }, 100)
          if (data?.status == 'valid') {
            window.dispatchEvent( new CustomEvent('product-discount', {'detail': data}) );
          }
        });/**/
      }
    }
  }
};

const menuDrawer = () => ({
  open: false,
  init() {
    var body = document.querySelector('body');
    this.$watch('open', value => {
      if (body) {
        if (value) {
          body.classList.add("overflow-hidden")
        } else {
          body.classList.remove("overflow-hidden")
        }
      }
    })
  }
});

const interactiveImage = () => {
  return {
    action: null,
    selectedVariantId: null,
    variants: null,
    performEvent() {
      console.log(this.action, this.variants)
      if (this.action == "atc") {
        const items = [];
        const variantsSplit = this.variants.split(",");
        for (let variant of variantsSplit) {
          variant = variant.trim();
          if (variant == 'current') {
            items.push({
              id: parseInt(this.selectedVariantId),
              quantity: 1
            });
          } else {
            items.push({
              id: parseInt(variant),
              quantity: 1
            });
          }
        }
        if (items.length > 0) {
          CartJS.addItems(items);
        }
      }
    },
    initialize(data) {
      this.action = data.action
      this.selectedVariantId = data.selectedVariant
      this.variants = data.variants
    }
  }
};


var EasyCart = (function (module) {
  
  const hooks = [];
  let registerHook;
  let callHook;

  registerHook = function (name, callback) {
    if (typeof hooks[name] === 'undefined') {
      hooks[name] = [];
    }
    hooks[name].push(callback);
  };

  hasRegisteredHook = function (name, callback) {
    if (typeof hooks[name] !== 'undefined') return true;
    return false;
  }; 

  callHook = function (name, args) {
    // console.log("callHook", name, args);
    if (typeof hooks[name] !== 'undefined')
      for (let i = 0; i < hooks[name].length; ++i)
        if (hooks[name][i](args) != true) {
          break;
        }
  };

  module = {
    registerHook,
    callHook,
    debugMode: false
  };

  return module;
})(EasyCart || {}); 


if (typeof ShopifyAPI === 'undefined') {
  ShopifyAPI = {};
}

// POST to cart/update.js returns the cart in JSON
ShopifyAPI.updateCart = function (cartUpdates, callback) {
  console.log("ShopifyAPI.updateCart", cartUpdates);
  const items = CartJS.cart.items;

  const keys = Object.keys(cartUpdates);
  const cartJSUpdates = [];
  // console.log(cartUpdates);
  let updated = false;
  const add = [];
  for (var i = 0; i < keys.length; i++) {
    let found = false;

    const id = parseInt(keys[i]);
    const quantity = parseInt(cartUpdates[id]);
    const timer = 1000;

    for (let j = 0; j < items.length; j++) {
      if (items[j].id == id) {
        found = true;
      }
      if (items[j].id == id && items[j].quantity != quantity && !updated) {
        // console.log("updateItem", items, j + 1, quantity);
        CartJS.updateItem(j + 1, quantity);
        updated = true;
      }
    }

    if (!found) {
      add.push({
        id,
        quantity,
      });
    }
  }

  for (var i = 0; i < add.length; i++) {
    CartJS.addItem(add[i].id, add[i].quantity);
  }
};

const cartDrawer = () => ({
  cart: null,
  total_price: 0,
  total_price_after_discount: 0,
  discount: 0,
  discountCodeInput: null, 
  validDiscountCode: null,
  codeStatus: null,
  open: false,
  firstTimeOpened: false,
  freeGift: null,
  loading: false,
  discountLoading: false,
  items: [],
  choiceOverlay: false,
  selectedFreeIds: [],
  freeProducts: [],
  giftSelectionSuccessful: false,
  selectedFreeVariants: [],
  maxFreeProducts: -1,
  cartUpsells: {},
  cartConfig: {},
  upsells: [],
  prices: [],
  initChoiceOverlay(args) {
    const {maxFreeProducts, freeProducts} = args;
    let currentFreeProductsCount = this.items.filter(item => item.price == 0)
    let freeProductFound = false
    let freeProductsFoundCount = 0

    if (currentFreeProductsCount > maxFreeProducts) {
      let i = 1;
      for (const item of this.items) {
        if (item.price == 0) {
          CartJS.removeItem(i)
        }
        i++;
      }
    } else {
      for (const freeProduct of freeProducts) {
        const f = this.items.find(item => item.variant_id == freeProduct.variants[0].variantId)
        if (f) {
          freeProductsFoundCount++
        }
      }
    }

    this.maxFreeProducts = maxFreeProducts
    this.freeProducts = freeProducts
    for (const product of this.freeProducts) {
      product.product_worth = "";
      product.available = true;
    }

    if (freeProductsFoundCount < maxFreeProducts) {
      this.openChoiceOverlay();
    }
  },
  confirmGiftChoice() {
    if (this.selectedFreeVariants.length < this.maxFreeProducts) {
      const free = this.maxFreeProducts - this.selectedFreeVariants.length;
      if (free == 1) {
        alert("Du hast noch ein Geschenk frei");
      } else {
        alert("Du hast noch " + free + " Geschenke frei");
      }
      this.giftSelectionSuccessful = false;
    } else {
      this.giftSelectionSuccessful = true;
      this.choiceOverlay = false;

      let i = 1
      // Remove other free gifts
      for (const item of this.items) {
        const f = this.selectedFreeVariants.find(s => s == item.variant_id)
        if (item.price == 0 && !f) {
          CartJS.removeItem(i)
        }
        i++;
      }

      // Add gifts that are not added yet
      for (const variant_id of this.selectedFreeVariants) {
        let alreadyInCart = false
        const f = this.items.find(item => item.variant_id == variant_id)

        if (f) alreadyInCart = true;

        if (!alreadyInCart) {
          CartJS.addItem(variant_id, 1)
        }
      }
    }
  },
  openChoiceOverlay() {
    this.choiceOverlay = true;
    this.loadImages();
  },
  addVariant(variantId) {
    CartJS.addItem(variantId, 1, {});
  },
  toggleFreeProduct(product) {
    if (!product.available) {
      return;
    }

    const variant = product.variants[0].variantId
    if (this.selectedFreeVariants.indexOf(variant) == -1) {
      this.selectedFreeVariants.push(variant)
    } else {
      const index = this.selectedFreeVariants.indexOf(variant);
      if (index > -1) {
        //console.log("remove ", variant)
        this.selectedFreeVariants.splice(index, 1);
      }
    }
    if (this.selectedFreeVariants.length > this.maxFreeProducts) {
      this.selectedFreeVariants.splice(0, 1);
    }
  },
  isFreeProductSelected(product) {
    const f = this.selectedFreeVariants.find(v => v.toString() == product.variants[0].variantId.toString());
    return !!f;
  },
  loadImages() {
    for (const product of this.freeProducts) {
      fetch(`/search?view=id&type=product&q=${encodeURI('id:' + product.productId)}`)
        .then(response => response.json())
        .then(response => {
          if (response.products && response.products.length > 0) {
            if (response.products[0].title) {
              product.title = response.products[0].title;
            }
            product.image = response.products[0].featured_image;
            product.product_worth = response.products[0].product_worth;
            product.available = !!response.products[0].available;
          }
        }).catch(err => {
        })
    }
  },
  updateUpsells() {
    let upsells = this.cartUpsells
    let _upsells = []
    let _allUpsellProducts = []
    let removeProducts = []
    const $this = this
    const upsellRulesApplied = []
    if (upsells) {
      for (const upsell of upsells) {
        const {mandatory_products, upsell_products} = upsell
        let ruleApplied = true
        for (const mandatoryProduct of mandatory_products) {
          
          const isInCart = $this.items.find(item => item.product_id == mandatoryProduct.id)
          if (!isInCart) {
            ruleApplied = false
          }
  
          upsellRulesApplied.push(upsell)
          for (const upsellProduct of upsell_products) {
            const upsellProductIsInCart = $this.items.find(item => item.product_id == upsellProduct.id)
            if (!isInCart && upsellProductIsInCart) {
              removeProducts.push(upsellProduct.id)
            }
          }
        }
        if (ruleApplied) {
          for (const upsellProduct of upsell_products) {
            const alreadyInUpsell = _upsells.find(item => item.id == upsellProduct.id)
            const isInCart = $this.items.find(item => item.product_id == upsellProduct.id)
            if (!alreadyInUpsell && !isInCart) {
              _upsells.push(upsellProduct)
            }
            _allUpsellProducts.push(upsellProduct.id)
          }
        }
      }
    }
    
    _upsells = _upsells.slice(0, this.cartConfig.maxUpsells)
    this.upsells = _upsells

    for (const productId of removeProducts) {
      const isInUpsell = _allUpsellProducts.find(item => item == productId)
      if (!isInUpsell) {
        const i = $this.items.findIndex(item => item.product_id == productId)
        CartJS.removeItem(i + 1)
        return
      }
    }
  },
  updateCart(cart) {
    if (cart) {
      var discountCodeCookie = getCookie('discount_code');
      if (discountCodeCookie && !this.discountCodeInput) {
        this.discountCodeInput = discountCodeCookie;
      }
      this.cart = cart
      this.total_price = cart.total_price
      this.total_price_after_discount = cart.total_price
      this.items = cart.items
      this.itemsPaid = cart.items.filter(item => item.price > 0)
      this.itemsFree = cart.items.filter(item => item.price == 0)
      this.updateUpsells();
      const $this = this
      
      setTimeout(() => {
        $this.loading = false
      }, 300)
      if ($this.firstTimeOpened) {
        $this.applyDiscountCode()
      }
    }
  },
  applyDiscountCode() {
    var $this = this;
    if (this.discountCodeInput && this.cart && this.items.length > 0) {
      this.discountLoading = true;
      
      let code = this.discountCodeInput;
      code = code.trim().toLowerCase();
      if (code && code.indexOf('?') > -1) {
        const codeSplit = code.split("?");
        code = codeSplit[0];
      }

      let shop = Shopify.shop;
      let checkoutVariants = this.items.map(paidItem => {
          return {
            "variant_id": paidItem.variant_id,
            "id": paidItem.variant_id,
            "quantity": paidItem.quantity,
            "properties": {},
            "final_line_price": paidItem.final_line_price
          }
      })
      let payload = {
        "checkout": {
          "country": "DE",
          "discount_code": code,
          "gift_cards": [],
          "line_items": checkoutVariants,
          "presentment_currency": "EUR"
        }
      }
  
      function applyDiscountCode() {
        return new Promise(function (resolve, reject) {
          // Apply discount code via /discount/<code> endpoint
          const discountUrl = "/discount/" + encodeURIComponent(code);
          
          fetch(discountUrl, {
            method: 'GET',
            credentials: 'same-origin',
            headers: {
              'Accept': 'application/json'
            }
          })
          .then(() => {
            // After applying discount, check cart status
            return fetch('/cart.json', {
              method: 'GET',
              credentials: 'same-origin',
              headers: {
                'Accept': 'application/json'
              }
            });
          })
          .then(response => response.json())
          .then(cartData => {
            resolve(cartData);
          })
          .catch(error => {
            console.error('Error applying discount code:', error);
            reject(error);
          });
        });
      }

      
      $this.total_price = this.cart.original_total_price
        
      applyDiscountCode().then(function(cart) {
        // Check if discount code was applied
        const discountApplied = cart?.discount_codes && 
                               cart?.discount_codes.length > 0 && 
                               cart?.discount_codes.some(dc => dc.code.toLowerCase() === code.toLowerCase() && dc.applicable);
        
        if (!discountApplied) {
          setTimeout(() => {
            $this.discountLoading = false;
          }, 500)
            
          $this.codeStatus = "invalid";
          $this.total_price = $this.cart.total_price
          $this.discount = 0
          $this.total_price_after_discount = $this.cart.total_price
          return
        }
        
        // Discount code was successfully applied
        $this.codeStatus = "valid";
        const total_price = cart.original_total_price;
        const total_after_discount = cart.total_price;
        const discount = cart.total_discount;
        
        console.log({
          total_price, total_after_discount, discount
        })
        
        $this.total_price = total_price
        $this.discount = discount
        $this.total_price_after_discount = total_after_discount

        
        if (discountApplied) {
          $this.validDiscountCode = code.trim().toUpperCase()
          setCookie("discount_code", code.trim().toUpperCase(), 1);
          
          var vdc = document.getElementById("cartDiscountCode");
          if (vdc) {
            vdc.value = code.trim().toUpperCase();
          }

          var vd = document.getElementById("cartDiscount");
          if (vd) {
            vd.value = code.trim().toUpperCase();
          }

          /**/

          

          setTimeout(function () {
            var cartItems = CartJS.cart.items;
            var items = [];
            let price = 0;
            let total = 0;
            for (var i = 0; i < cartItems.length; i++) {
              items.push({
                variant: cartItems[i].variant_id,
                price: cartItems[i].price,
                quantity: cartItems[i].quantity
              })
              total += cartItems[i].price * cartItems[i].quantity;
              price += cartItems[i].price;
            }
            if (price == 0) {
              CartJS.clear();
            } else {
              if (code.trim().toLowerCase().indexOf("bday") > -1
                || code.trim().toLowerCase().indexOf("special") > -1
                || code.trim().toLowerCase().indexOf("1year") > -1) {
                const k = cartItems.find(item => item.variant_id == 43751988101386)
                if (!k && total >= 8000) {
                  CartJS.addItem(43751988101386, 1)
                } else if (k && total < 8000) {
                  const ki = cartItems.findIndex(item => item.variant_id == 43751988101386)
                  CartJS.removeItem(ki + 1)
                }
                /**/

                /**document.dispatchEvent(new CustomEvent('EasyCart:after_discount_code_check', {
                  detail: {
                    code: code.trim(),
                    items: items
                  }
                }));*/

                //EasyCart.callHook('after_discount_code_check', [code.trim(), items]);
              } else {
                //EasyCart.callHook('after_discount_code_check', [code.trim(), items]);
              }
            }
          }, 500);
        }

        if ($this.freeGift) {
          const currentCartItems = CartJS.cart.items;
          const variantId = $this.freeGift.variant_id
          const freeFrom = $this.freeGift.from * 100;
          const giftCode = $this.freeGift.code?.trim()?.toUpperCase();

          console.log({
            giftCode,
            validDiscountCode: $this.validDiscountCode,
            total_price: $this.total_price_after_discount,
            from: freeFrom
          })
          if (discountApplied && (giftCode == $this.validDiscountCode || giftCode == "*") && $this.total_price_after_discount >= freeFrom) {
            const existingVariant = currentCartItems.find(item => item.variant_id == variantId);
            console.log("GO!!");
            if (!existingVariant) {
              console.log("ADD")
              CartJS.addItem(variantId, 1)
            }
          } else {
            const existingVariantIndex = currentCartItems.findIndex(item => item.variant_id == variantId);
            if (existingVariantIndex > -1) {
              console.log("REMOVE")
              CartJS.removeItem(existingVariantIndex + 1)
            }
          }
        }
        
        setTimeout(() => {
          $this.discountLoading = false;
        }, 500)
      });

      /*
      const data = { cart: JSON.parse(JSON.stringify(this.cart)), code: code, shop: shop };
      fetch('https://secretbrands-checkout-api.digitalsprung.de/checkout', {
        method: 'POST', // or 'PUT'
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      })
      .then(response => response.json())
      .then(data => {
        setTimeout(() => {
          $this.discountLoading = false
        }, 100)
        
        if (data.checkoutCart) {
          $this.discount = data.checkoutCart.discount
          $this.total_price = data.checkoutCart.subtotal
          $this.total_price_after_discount = data.checkoutCart.total
        } else {
          $this.discount = 0
          $this.total_price = $this.cart.total_price
          $this.total_price_after_discount = $this.cart.total_price
        }
        if (data.status) {
          $this.codeStatus = data.status
        }
        if (data.checkoutCart && data.checkoutCart.discount == 0) {
          $this.codeStatus = 'invalid';
        }
        if ($this.codeStatus == 'valid') {
          $this.validDiscountCode = code.trim().toUpperCase()
          $this.discountCodeInput = code.trim().toUpperCase()
          setCookie("discount_code", code.trim().toUpperCase(), 1);
          setCookie("discount_code_referrer", code.trim().toUpperCase(), 1);

          var vdc = document.getElementById("cartDiscountCode");
          vdc && (vdc.value = code.trim().toUpperCase());

          var vd = document.getElementById("cartDiscount");
          vd && (vd.value = code.trim().toUpperCase());

          if ($this.freeGift) {
            const currentCartItems = CartJS.cart.items;
            const variantId = $this.freeGift.variant_id
            const freeFrom = $this.freeGift.from * 100;
            const giftCode = $this.freeGift.code?.trim()?.toUpperCase();
            if ((giftCode == $this.validDiscountCode || giftCode == "*") && $this.total_price >= $this.freeGift.from) {
              const existingVariant = currentCartItems.find(item => item.variant_id == variantId);
              if (!existingVariant) {
                CartJS.addItem(variantId, 1)
              }
            } else {
              const existingVariantIndex = currentCartItems.findIndex(item => item.variant_id == variantId);
              if (existingVariantIndex > -1) {
                CartJS.removeItem(existingVariantIndex + 1)
              }
            }
          }

          setTimeout(() => {
            var cartItems = CartJS.cart.items;
            var items = [];
            let price = 0;
            for (var i = 0; i < cartItems.length; i++) {
              items.push({
                variant: cartItems[i].variant_id,
                price: cartItems[i].price,
                quantity: cartItems[i].quantity
              })
              price += cartItems[i].price;
            }
            if (price == 0) {
              CartJS.clear();
            } else {
              if (typeof EasyCart !== "undefined") {
                //EasyCart.callHook('after_discount_code_check', [code.trim(), items]);
              }
            }
          }, 500);
        } else {
          $this.validDiscountCode = null
        }
      })

      */
    }
  },
  decreaseQuantity(item) {
    this.loading = true
    const index = this.items.findIndex(cartItem => cartItem.id == item.id)
    CartJS.updateItem(index + 1, item.quantity - 1);
  },
  removeItem(item) {
    CartJS.updateItem(index + 1, item);
  },
  increaseQuantity(item) {
    this.loading = true
    const index = this.items.findIndex(cartItem => cartItem.id == item.id)
    CartJS.updateItem(index + 1, item.quantity + 1);
  },
  removeItem(item) {
    this.loading = true
    const index = this.items.findIndex(cartItem => cartItem.id == item.id)
    CartJS.removeItem(index + 1);
  },
  setup({upsells, config, prices, singleFreeGift}) {
    this.prices = prices;
    this.cartUpsells = upsells;
    this.cartConfig = config;
    this.freeGift = singleFreeGift;
  },
  compareAtPrice(variantId) {
    const p = this.prices.find(item => {
      const {variants} = item
      const v = variants.find(vItem => vItem.id == variantId)
      return v
    });
    if (p) {
      const {variants} = p
      const v = variants.find(vItem => vItem.id == variantId)
      if (v && v.compare_at_price > 0 && v.compare_at_price > v.price) {
        return v.compare_at_price
      }
    }
    return 0
  },
  initialize(cart) {
    var $this = this
    this.$watch('open', value => {
      if (value && !$this.firstTimeOpened) {
        $this.firstTimeOpened = true
        $this.applyDiscountCode()
      }
      if (body) {
        if (value) {
          body.classList.add("overflow-hidden")
        } else {
          body.classList.remove("overflow-hidden")
        }
      }
    });

    if (!cart) return
    this.updateCart(cart)
    var body = document.querySelector('body');
    
  }
});




function parse_query_string(query) {
  var vars = query.split("&");
  var query_string = {};
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split("=");
    var key = decodeURIComponent(pair[0]);
    var value = decodeURIComponent(pair[1]);
    // If first entry with this name
    if (typeof query_string[key] === "undefined") {
      query_string[key] = decodeURIComponent(value);
      // If second entry with this name
    } else if (typeof query_string[key] === "string") {
      var arr = [query_string[key], decodeURIComponent(value)];
      query_string[key] = arr;
      // If third or later entry with this name
    } else {
      query_string[key].push(decodeURIComponent(value));
    }
  }
  return query_string;
}


const discountCodeInfo = () => {
  return {
    show: false,
    text: null,
    initialize(textTemplate) {
      const cc = getCookie("discount_code");
      var query = window.location.search.substring(1);
      var qs = parse_query_string(query)

      if (cc) {
        let coupon_code = cc.toString();
        coupon_code = coupon_code.split('&')[0];
    
        if (qs.discount_note !== undefined && coupon_code != "") {
          this.text = textTemplate.replace('[discount_code]', coupon_code.toUpperCase())
          this.show = true
          if (window.discountCodeCalculation) {
            setCookie("discount_code_referrer", coupon_code.toUpperCase(), 1);
          }
        }
      }
      
      if (window.discountCodeCalculation) {
        const dcr = getCookie("discount_code_referrer");
        if (dcr && window.productData) {
          var coupon_code = dcr.toString();
          var url = `https://secretbrands-checkout-api.digitalsprung.de/checkout/${coupon_code.toLowerCase()}/${window.productData.productId}/${window.productData.variantId}?shop=${Shopify.shop}&price=${window.productData.price}`

          fetch(url)
          .then(response => response.json())
          .then(data => {
            if (data?.status == 'valid') {
              window.dispatchEvent( new CustomEvent('product-discount', {'detail': data}) );
            }
          });
        }
      }
    }
  }
}

const videoPreloader = () => {
  return {
    load: false,
    url: null,
    id: null,
    startLoading() {
      this.load = true;
      document.addEventListener("pageshow", function(event) {
        const video = document.getElementById(`video-${id}`);
        if (video) {
          if(video.muted) {
            video.muted = false;
          } else {
            video.muted = true;
            video.play()
          }
        }
      });
    },
    initialize(id, url) {
      this.id = id;
      this.url = url;
    }
  }
}

const stickyCartForm = () => {
  return {
    product: null,
    variants: [],
    selectedVariant: null,
    quantity: 1,
    decreaseQuantity() {
      this.quantity -= 1
      if (this.quantity <= 1) {
        this.quantity = 1
      }
      window.dispatchEvent( new CustomEvent('quantity-updated', {'detail': {quantity: this.quantity}}))
    },
    increaseQuantity() {
      this.quantity = this.quantity + 1
      window.dispatchEvent( new CustomEvent('quantity-updated', {'detail': {quantity: this.quantity}}))
    },
    selectVariant(id) {
      if (id) {
        this.selectedVariant = this.product.variants.find(item => item.id == id)
      }
    },
    initialize(product, variantId) {
      this.product = product
      if (product) {
        this.variants = product.variants
        this.selectedVariant = product.variants.find(item => item.id == variantId)
      }
    }
  }
}
